import styled from 'styled-components';

const Info = styled.div`
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid gray;
`;

export default Info;
